import * as yup from "yup";

const socialNetworkDtoSchema = yup.object().shape({
  profileViewId: yup.string(),
  id: yup.string(),
  labelName: yup.string(),
  username: yup.string(),
});

const addressSchema = yup.object().shape({
  profileViewId: yup.string(),
  id: yup.string(),
  addressType: yup.object().shape({
    name: yup.string(),
  }),
  addressStreet1: yup.string().nullable(),
  addressStreet2: yup.string().nullable(),
  addressCity: yup.string().nullable(),
  addressCountry: yup.string().nullable(),
  addressPostalCode: yup.string().nullable(),
  createdDate: yup.string().nullable(),
});

export const profileSchema = yup.object().shape({
  id: yup.string(),
  firstName: yup.string(),
  secondName: yup.string(),
  lastName: yup.string(),
  birthday: yup.string().nullable(),
  phoneLabel: yup.string().nullable(),
  phoneNumber: yup.string().nullable(),
  emailLabel: yup.string().nullable(),
  emailWebsite: yup.string().email("Invalid email format").nullable(),
  socialNetworkDtos: yup.array().of(socialNetworkDtoSchema).nullable(),
  pinCode: yup.string().nullable(),
  language: yup.string().nullable(),
  username: yup.string().nullable(),
  address: yup.array().of(addressSchema),
});
